import { useState, useEffect } from 'react';
import { announcementsAPI } from '../../utils/api';
import PublicLayout from '../../components/layout/PublicLayout';
import useSEO from '../../hooks/useSEO';
import { MegaphoneIcon } from '@heroicons/react/24/outline';

export default function AnnouncementsPage() {
  useSEO({ title: 'Announcements — JNF', description: 'Latest news and announcements from Jamuiyat Nasir Al-Fridaous Al Tijaniyyah.' });

  const [items, setItems]     = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    announcementsAPI.getAll()
      .then(r => setItems(r.data.data || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <PublicLayout>
      <div className="max-w-4xl mx-auto px-4 py-12">

        <div className="text-center mb-10">
          <p className="text-cyan-500 text-xs font-semibold uppercase tracking-widest mb-2">✦ Latest News ✦</p>
          <h1 className="section-title">Announcements</h1>
          <p className="text-gray-400 mt-2 text-sm">Updates, notices, and news from JNF</p>
        </div>

        {loading ? (
          <div className="space-y-4">
            {[1,2,3].map(i => <div key={i} className="h-32 bg-gray-100 rounded-2xl animate-pulse" />)}
          </div>
        ) : items.length === 0 ? (
          <div className="text-center py-20">
            <MegaphoneIcon className="h-12 w-12 text-gray-200 mx-auto mb-4" />
            <p className="text-gray-400 font-medium">No announcements at this time.</p>
            <p className="text-gray-300 text-sm mt-1">Check back soon, in sha Allah.</p>
          </div>
        ) : (
          <div className="space-y-4">
            {items.map(item => (
              <div
                key={item.id}
                className={`bg-white rounded-2xl border shadow-sm p-6 transition-shadow hover:shadow-md ${item.is_pinned ? 'border-amber-200' : 'border-gray-100'}`}
              >
                {item.is_pinned && (
                  <span className="badge bg-amber-100 text-amber-700 text-xs mb-3 inline-block">📌 Pinned</span>
                )}
                <h2 className="font-bold text-navy-800 text-lg mb-1">{item.title}</h2>
                {item.title_ar && (
                  <p className="arabic text-navy-600 text-base mb-2">{item.title_ar}</p>
                )}
                <p className="text-gray-600 text-sm leading-relaxed mb-3 whitespace-pre-line">{item.body}</p>
                {item.body_ar && (
                  <div className="bg-navy-50 rounded-xl p-4 border border-navy-100 mb-3">
                    <p className="arabic text-navy-700 leading-loose text-sm">{item.body_ar}</p>
                  </div>
                )}
                <div className="flex items-center justify-between pt-3 border-t border-gray-100">
                  <p className="text-gray-300 text-xs">
                    {item.created_at ? new Date(item.created_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' }) : ''}
                  </p>
                  {item.author && (
                    <p className="text-cyan-500 text-xs font-medium">{item.author}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </PublicLayout>
  );
}
